import { render, staticRenderFns } from "./consultation_patients.vue?vue&type=template&id=361d7edf&"
import script from "./consultation_patients.vue?vue&type=script&lang=js&"
export * from "./consultation_patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports